import Transitions from "Components/Transitions/Transitions";
import ChallengeCard from "./LandingComponents/ChallengeCard/ChallengeCard";
import UseInnerWidth from "hooks/UseInnerWidth";

function ChallengeLanding() {
  const width = UseInnerWidth();

  return (
    <>
      <div className="w-full flex-col mt-10 md:mt-0 flex gap-4 items-center ">
        <div>
          <div className="font-N_Medium text-4xl text-center">
            Choose Your Path to Success
          </div>
          <div className="w-[60%] mb-8 mt-4 text-white-opacity text-center text-base m-[auto]">
            Start with a free trial or unlock the full experience with our paid
            plan—your journey, your choice.
          </div>
        </div>
        <div className={`${width <= 1024 ? "w-full" : "w-[55rem]"}`}>
          <ChallengeCard />
        </div>
      </div>
    </>
  );
}

export default ChallengeLanding;
